import get from "lodash.get"

export { get }

export function pick<TValue, TKey extends keyof TValue>(
  parent: TValue,
  keys: Array<TKey>,
): Pick<TValue, TKey> {
  // biome-ignore lint/suspicious/noExplicitAny: Using any with explicit return types
  return keys.reduce((obj: any, key: TKey) => {
    obj[key] = parent[key]
    return obj
    // biome-ignore lint/suspicious/noExplicitAny: Using any with explicit return types
  }, {} as any)
}

export function toArray<T>(value: T | T[]): T[] {
  return Array.isArray(value) ? value : [value]
}

type ColumnHeader = {
  key: string
  label: string
}

// Utility function to convert JSON array to CSV
export function jsonToCsv<Row extends Record<string, unknown>>(
  jsonArray: Row[],
  headers: ColumnHeader[],
): string {
  const csvRows = [
    headers
      .map((header) => header.label)
      .join(","), // Add the headers
    ...jsonArray.map((row) =>
      headers
        .map((header) => String(get(row, header.key, "")).replace(/,/g, " "))
        .join(","),
    ),
  ]

  return csvRows.join("\n")
}
